document.addEventListener('DOMContentLoaded', function () {
  const menuContainer = document.querySelector('.header__inline-menu');
  if (!menuContainer) {
    return;
  }

  // Backdrop element voor de fade-overlay achter het mega menu
  let backdrop = document.querySelector('.backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'backdrop';
    document.body.appendChild(backdrop);
  }

  // Close delay om flikkeren te voorkomen (Coolblue-stijl)
  let closeTimeout = null;
  const CLOSE_DELAY = 200;

  function clearCloseTimeout() {
    if (closeTimeout) {
      clearTimeout(closeTimeout);
      closeTimeout = null;
    }
  }

  function closeAllMenus() {
    document.querySelectorAll('.header__inline-menu details[open]').forEach(openDetail => {
      openDetail.removeAttribute('open');
    });
  }

  function scheduleClose() {
    clearCloseTimeout();
    closeTimeout = setTimeout(closeAllMenus, CLOSE_DELAY);
  }

  const listItems = menuContainer.querySelectorAll('.list-menu > li');

  listItems.forEach(listItem => {
    const details = listItem.querySelector('details');
    if (details) {
      const summary = details.querySelector('summary');

      // Klik navigeert naar de hoofdcollectie
      if (summary) {
        summary.addEventListener('click', (event) => {
          if (window.innerWidth >= 990) {
            const url = summary.getAttribute('data-url');
            if (url) {
              window.location.href = url;
            }
          }
        });
      }

      // Hover opent het dropdown menu
      listItem.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          clearCloseTimeout();
          document.querySelectorAll('.header__inline-menu details[open]').forEach(openDetail => {
            if (openDetail !== details) {
              openDetail.removeAttribute('open');
            }
          });
          details.setAttribute('open', '');
        }
      });
    } else {
      // Simpele link: sluit open menu's met delay
      listItem.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 990) {
          scheduleClose();
        }
      });
    }
  });

  // Sluit menu's wanneer muis het gehele menu-gebied verlaat (met delay)
  menuContainer.addEventListener('mouseleave', () => {
    if (window.innerWidth >= 990) {
      scheduleClose();
    }
  });

  // Annuleer sluiting wanneer muis terug het menu-gebied in komt
  menuContainer.addEventListener('mouseenter', () => {
    if (window.innerWidth >= 990) {
      clearCloseTimeout();
    }
  });

  // Klik op backdrop sluit het menu direct
  backdrop.addEventListener('click', () => {
    clearCloseTimeout();
    closeAllMenus();
  });

  // Mega menu full-width: bereken offset van nav naar viewport-rand
  function updateMegaMenuOffset() {
    var rect = menuContainer.getBoundingClientRect();
    menuContainer.style.setProperty('--mega-menu-offset-left', -rect.left + 'px');
  }
  updateMegaMenuOffset();
  window.addEventListener('resize', updateMegaMenuOffset);
});